import React from "react";
import cs from "classnames";
import { Label, LabelProps } from "reactstrap";
import { InformationBox } from "../InformationBox/InformationBox";
import { Icon, IconDefinition } from "../Icon/Icon";

import "./LabelWithInformationBox.scss";

export type LabelDirectionType = "left" | "right";

interface Props extends LabelProps {
  title: string;
  message?: string;
  direction?: LabelDirectionType;
  className?: string;
  informationBoxClassName?: string;
  icon?: IconDefinition;
}

export const LabelWithInformationBox = (props: Props) => {
  const { direction, className, informationBoxClassName, icon } = props;

  const classes = cs("LabelWithInformationBox", className);

  return (
    <div className={classes}>
      {icon && <Icon icon={icon} />}
      <Label for={props.for}>{props.title}</Label>
      {props.message && (
        <InformationBox
          message={props.message}
          className={informationBoxClassName}
        />
      )}
    </div>
  );
};
